var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-show"},[_c('keep-alive',[(_vm.isMobile)?_c('ProductShowReordered'):_c('ProductShow')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }